(() => {
  const rowSelector = '#mini-cart [data-item], [data-cart-items] [data-cart-item]';

  function updateCartItemPrices() {
    if (!document.querySelector(rowSelector)) return;

    fetch(window.Shopify.routes.root + 'cart?section_id=cart-item-prices')
      .then((response) => response.text())
      .then((html) => {
        const prices = new DOMParser().parseFromString(html, 'text/html');

        document.querySelectorAll(rowSelector).forEach((row) => {
          const key = row.querySelector('[data-key]')?.dataset.key;
          const price = prices.querySelector(`[data-cart-item-price="${key}"]`);
          const target = row.querySelector('div.text-16, div.text-15');
          if (price && target) target.innerHTML = price.innerHTML;
        });
      })
      .catch(() => {});
  }

  const observer = new MutationObserver(updateCartItemPrices);
  document.querySelectorAll('#mini-cart, [data-cart-items]').forEach((list) => {
    observer.observe(list, { childList: true });
  });
})();
